import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError, EMPTY } from 'rxjs';
import {
  SECURITY_GET_TERMS_PATH,
  SECURITY_SAVE_TERMS_PATH,
  SECURITY_USER_ENTITLEMENTS_PATH,
} from 'src/app/constants/UserAPIConstants';
import {
  PUBLIC_ERROR_PATH,
  PUBLIC_LOGIN_PATH,
  LOGOUT_REASONS,
  LOGOUT,
} from 'src/app/constants/NextGenConstants';
import { EntitlementResponse } from 'src/app/models/EntitlementResponse';
import { TermsOfUseResponse } from 'src/app/models/TermsOfUseResponse';
import { AuthService } from '../security/auth.service';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  constructor(
    protected httpClient: HttpClient,
    private readonly router: Router,
    private readonly authService: AuthService,
  ) {}

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'FID-LOG-TRACKING-ID': uuidv4(),
    });
  }

  // Fetches all entitlement groups available for the authenticated external user.
  getEntitlements(): Observable<EntitlementResponse[]> {
    return this.httpClient
      .post<EntitlementResponse[]>(SECURITY_USER_ENTITLEMENTS_PATH, null, {
        headers: this.getHeaders(),
      })
      .pipe(catchError((error) => this.handleAuthFlowError(error)));
  }

  saveTerms(isAccepted: boolean): Observable<void> {
    return this.httpClient
      .post<void>(
        SECURITY_SAVE_TERMS_PATH,
        { isAccepted },
        {
          headers: this.getHeaders(),
        },
      )
      .pipe(catchError((error) => this.handleAuthFlowError(error)));
  }

  getTerms(): Observable<TermsOfUseResponse> {
    return this.httpClient
      .get<TermsOfUseResponse>(SECURITY_GET_TERMS_PATH, {
        headers: this.getHeaders(),
      })
      .pipe(catchError((error) => this.handleAuthFlowError(error)));
  }

  private handleAuthFlowError(error: unknown): Observable<never> {
    if (error instanceof HttpErrorResponse && error.status === 401) {
      this.authService.logout();
      void this.router.navigate([PUBLIC_LOGIN_PATH], {
        queryParams: { ccview: LOGOUT, reason: LOGOUT_REASONS[1] },
      });
      return EMPTY;
    }

    void this.router.navigate([PUBLIC_ERROR_PATH]);
    return EMPTY;
  }
}
